import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "manifold-claim" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "spinner" }, null, -1)

import { onMounted, ref } from 'vue';
import apiHelpers from '@/api/apiHelpers';
import ClaimBuyOnlyBody from '@/components/ClaimBuyOnlyBody.vue';
import ErrorPage from '@/components/ErrorPage.vue';
import { useClaimStore } from '@/store/claimStore';

export type ClaimProps = {
  id: number;
  fallbackProvider?: string;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'MClaimBuyOnly',
  props: {
    id: null,
    fallbackProvider: null
  },
  setup(__props: any) {

const props = __props as {
  id: number;
  fallbackProvider?: string;
};



const store = useClaimStore();
const error = ref<any>();

onMounted(async () => {
  try {
    const instance = await apiHelpers.fetch(`/public/instance/data?id=${props.id}`);
    await store.initialize(instance, props.fallbackProvider);
  } catch (error) {
    // @ts-expect-error
    error.value = error;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(store).initialized)
      ? (_openBlock(), _createBlock(ClaimBuyOnlyBody, { key: 0 }))
      : (Boolean(error.value))
        ? (_openBlock(), _createBlock(ErrorPage, {
            key: 1,
            error: error.value
          }, null, 8, ["error"]))
        : (_openBlock(), _createBlock(_Transition, {
            key: 2,
            id: "claim-complete-loading",
            name: "fade"
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }))
  ]))
}
}

})